<template>
  <div class="parent_div">
    <dd-header />
    <div class="wrapper">
      <template>
        <dd-banner
          ref="ddBannerListRef"
          :swipeList="cmpbunnerList"
          :swiperOptions="categoryOptions"
          :horizontalMode="false"
        />
      </template>
      <!-- メインコンテンツ -->
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <dd-content
          ref="mainContent"
        />
      </div>
    </div>
    <dd-footer />
  </div>
</template>
<script>
import * as App from '../../utils/App'

import DDLeftMenu from '../components/top/DcLeftMenu'
import DDContent from '../components/top/DcTopContent'
import DcHeader from '../components/common/DcHeader'
import DcFooter from '../components/common/DcFooter'
import DcBannerSwiper from '../components/common/DcBannerSwiper'
import {DC_STORAGE_KEY, STRUCT_CORP_ID_ST, STRUCT_CORP_ID_ED} from '../../constants/App'
export default {
  components: {
    'dd-menu': DDLeftMenu,
    'dd-content': DDContent,
    'dd-header': DcHeader,
    'dd-footer': DcFooter,
    'dd-banner': DcBannerSwiper
  },
  data () {
    return {
      categoryOptions: {
        slidesPerView: 'auto',
        slidesPrGroup: 2,
        slidesPerColumn: 1,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        SimulateTouch: true,
        touchStartPreventDefault: false,
        preventClicks: true,
        centeredSlides: false,
        spaceBetween: 10,
        initialSlide: 0,
        // loop: true,
        autoPlay: {
          delay: 3000,
          pauseOnMouseEnter: true
        }
      },
      bannerList: [
        {id: 1, img: this.getImage('top/content/sketchorder_header.webp'), clickable: false, link: 'https://sketchorder.domans-cloud.com'},
        {id: 2, img: this.getImage('top/content/header.webp'), clickable: false}
      ],
      bannerList2: [
        {id: 2, img: this.getImage('top/content/header.webp'), clickable: false}
      ],
      user: {}
    }
  },
  methods: {
    getImage: function (image) {
      return App.getMmstyleResource(image)
    },
    goSketchOrder: function () {
      this.$router.push({
        name: 'DcSketchOrder'
      })
    }
  },
  computed: {
    isLogin: function () {
      if (!this.user || Object.keys(this.user).length <= 0) return false
      if (this.user.userId === undefined) return false
      if (this.user.userLevel === 4) return false
      return true
    },
    isSketchOrder: function () {
      if (process.env.SKETCH_ORDER !== 1) {
        return false
      }
      return true
    },
    isHaseko: function () {
      return (this.user && this.user.corpId >= STRUCT_CORP_ID_ST && this.user.corpId <= STRUCT_CORP_ID_ED)
    },
    cmpbunnerList: function () {
      if (!this.isHaseko) return this.bannerList
      return this.bannerList2
    }
  },
  mounted () {
  },
  created: function () {
    this.user = App.getLocalStorage(DC_STORAGE_KEY.USER_INFO)
    if (this.$route.query.code) {
      let paramForm = {
        code: this.$route.query.code,
        payment: this.$route.query.payment
      }
      App.setLocalStorage(DC_STORAGE_KEY.INVITE_CODE, paramForm)
    }
    console.log(process.env.SKETCH_ORDER)
  }
}
</script>
<style src="../css/dctop4.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcTop.vue